import React from "react";
import { data_z_dniem } from "../../../../functions/dataFormat";

const MieszkaniecDaneWodaRozliczenieWydrukNaglowek = () => {

    return (
        <section
            style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "20px"
            }}
        >
            <div
                style={{width: "fit-content", textAlign: "center", fontSize: "0.8rem"}}
            >
                <b>Administrator Wspólnoty</b><br/>
                Przedsiębiorstwo Usługowe eM3 s.j.<br/>
                Biuro Obsługi Nieruchomości<br/>
                Mojsiewicz & Stanek s.c.<br/>
                ul. Mieszka I 57/6<br/>
                66-400 Gorzów Wielkopolski<br/>
                t: 95 724 19 08, 690 240 779<br/>
                www.bonadministrator.pl
            </div>
            <div
                style={{width: "fit-content"}}
            >
                <p style={{lineHeight: "1.4rem", fontSize: "0.8rem"}}>
                    {`Gorzów Wlkp. ${data_z_dniem(new Date())}`} 
                </p>
            </div>
        </section>
    )
}

export default MieszkaniecDaneWodaRozliczenieWydrukNaglowek;